import {createSelector, MemoizedSelector} from '@ngrx/store';
import {ZonaExclusion, zonasExclusionAdapter, ZonasExclusionState} from './zonas-exclusion.state';

import {FeaturesState, selectFeatures} from '../../../features.state';

export const getError = (state: ZonasExclusionState): any => state.error;

export const getIsLoading = (state: ZonasExclusionState): boolean =>
  state.isLoading;

export const selectZonasExclusionState = createSelector(
  selectFeatures,
  (state: FeaturesState) => state.zonasExclusion
);

export const selectAllZonasExclusion: (state: object) => ZonaExclusion[] = zonasExclusionAdapter.getSelectors(
  selectZonasExclusionState
).selectAll;

export const selectZonaExclusionById = (id: string) =>
  createSelector(
    selectAllZonasExclusion,
    (allZonasExclusion: ZonaExclusion[]) => {
      if (allZonasExclusion) {
        return allZonasExclusion.find(z => z.zonaExclusionId === id);
      } else {
        return null;
      }
    }
  );

export const selectZonasExclusionError: MemoizedSelector<object,
  any> = createSelector(
  selectZonasExclusionState,
  getError
);

export const selectZonasExclusionIsLoading: MemoizedSelector<object,
  boolean> = createSelector(
  selectZonasExclusionState,
  getIsLoading
);
